import { UserRoles } from "@/types/user.type";
import { Feature } from "./Feature.constant";

export const FeaturePermission = {
  [Feature.BROWSE]: ["*"],
  [Feature.PROJECT_ADMIN]: ["*"],
  [Feature.DASHBOARD]: ["*"],
  [Feature.STOCK_MANAGEMENT]: [
    UserRoles.SUPER_ADMIN,
    UserRoles.COMPANY_ADMIN,
    UserRoles.PARTNER_ADMIN
  ],
  [Feature.ADMIN]: [
    UserRoles.SUPER_ADMIN,
    UserRoles.COMPANY_ADMIN,
    UserRoles.PARTNER_ADMIN
  ],
  [Feature.REPORTS]: [
    UserRoles.SUPER_ADMIN,
    UserRoles.COMPANY_ADMIN,
    UserRoles.PARTNER_ADMIN
  ],
  [Feature.LOGS]: [
    UserRoles.SUPER_ADMIN,
    UserRoles.COMPANY_ADMIN,
    UserRoles.PARTNER_ADMIN
  ]
} satisfies Record<keyof typeof Feature, UserRoles[] | "*"[]>;
